import { createApp } from 'vue'
import { clerkPlugin } from '@clerk/vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import './styles/main.css'

const app = createApp(App)

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!clerkPublishableKey) {
  console.error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable')
}

app.use(clerkPlugin, {
  publishableKey: clerkPublishableKey,
  // Add proper configuration for Clerk's sign-up flow
  appearance: {
    layout: {
      socialButtonsVariant: 'iconButton'
    }
  },
  // Define redirect URLs for sign-up/sign-in using new properties
  signInUrl: '/auth/sign-in',
  signUpUrl: '/auth/sign-up',
  // Use new redirect properties instead of deprecated ones
  signInFallbackRedirectUrl: '/play',
  signUpFallbackRedirectUrl: '/profile/setup',
  // Use path routing to match Vue Router configuration
  routingStrategy: 'path'
})

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

app.use(router)
app.mount('#app')
